export const FETCH_USER_EVENT_TYPES = 'dt/events/FETCH_USER_EVENT_TYPES';
export const RECEIVE_USER_EVENT_TYPES = 'dt/events/RECEIVE_USER_EVENT_TYPES';
export const REQUEST_NOTIFY_EVENTS = 'dt/events/REQUEST_NOTIFY_EVENTS';
export const DELETE_USER_EVENT = 'dt/events/DELETE_USER_EVENT';
export const EXCLUDE_USER_EVENT_OCCURRENCE = 'dt/events/EXCLUDE_USER_EVENT_OCCURRENCE';
export const RECEIVE_USER_EVENTS = 'dt/events/RECEIVE_USER_EVENTS';
export const RECEIVE_SERIES_EVENTS = 'dt/events/RECEIVE_SERIES_EVENTS';
export const FETCH_SERIES_EVENTS = 'dt/events/FETCH_SERIES_EVENTS';
export const FETCH_EXPORT_EVENTS = 'dt/events/FETCH_EXPORT_EVENTS';
export const STOP_FETCH_EXPORT_EVENTS = 'dt/events/STOP_FETCH_EXPORT_EVENTS';
export const EXPORTING_DONE = 'dt/events/EXPORTING_DONE';
export const RECEIVE_NOTIFY_EVENTS = 'dt/events/RECEIVE_NOTIFY_EVENTS';
export const UPLOAD_IOT_EVENTS_FILE = 'dt/events/UPLOAD_IOT_EVENTS_FILE';
export const IOT_EVENTS_UPDATED = 'dt/events/IOT_EVENTS_UPDATED';
export const BULK_OVERWRITE_SERIES = 'dt/events/BULK_OVERWRITE_SERIES';
export const EVENT_IMPORT_ERRORS = 'dt/events/EVENT_IMPORT_ERRORS';
export const EVENT_IMPORTED_AT = 'dt/events/EVENT_IMPORTED_AT';
export const SET_IMPORT_ORDER = 'dt/events/SET_IMPORT_ORDER';

export const requestUserEventTypes = () => ({
  type: FETCH_USER_EVENT_TYPES,
});

export const receiveUserEventTypes = (types) => ({
  type: RECEIVE_USER_EVENT_TYPES,
  userEventTypes: types,
});

export const requestNotifyEvents = (siteId) => ({
  type: REQUEST_NOTIFY_EVENTS,
  siteId,
});

export const receiveUserEvents = (events) => ({
  type: RECEIVE_USER_EVENTS,
  events,
});

export const receiveSeriesEvents = (events) => ({
  type: RECEIVE_SERIES_EVENTS,
  events,
});

export const requestSeriesEvents = (query, callback) => ({
  type: FETCH_SERIES_EVENTS,
  query,
  callback,
});

export const receiveNotifyEvents = (eventCounts) => ({
  type: RECEIVE_NOTIFY_EVENTS,
  eventCounts,
});

export const deleteUserEvent = (eventId, callback) => ({
  type: DELETE_USER_EVENT,
  eventId,
  callback,
});

export const excludeUserEventOccurrence = (event, callback) => ({
  type: EXCLUDE_USER_EVENT_OCCURRENCE,
  event,
  callback,
});

export const bulkOverwriteEventSeries = (data) => ({
  type: BULK_OVERWRITE_SERIES,
  data,
});

export const addIotEventsFile = (file) => ({
  type: UPLOAD_IOT_EVENTS_FILE,
  file,
});

export const iotEventsAdded = (updatedAt) => ({
  type: IOT_EVENTS_UPDATED,
  updatedAt,
});

export const fetchExportEvents = ({ eventType, query, perRequestCallback, exportCallback }) => ({
  type: FETCH_EXPORT_EVENTS,
  eventType,
  query,
  perRequestCallback,
  exportCallback,
});

export const stopFetchExportEvents = () => ({ type: STOP_FETCH_EXPORT_EVENTS });

export const exportingDone = () => ({
  type: EXPORTING_DONE,
});

export const setImportErrors = (errors) => ({
  type: EVENT_IMPORT_ERRORS,
  errors,
});

export const setImportOrder = (order) => ({
  type: SET_IMPORT_ORDER,
  order,
});

// Fix this to reset once the timeline panel actually uses the state for recieving events
export const setImportedAt = (date) => ({
  type: EVENT_IMPORTED_AT,
  date,
});
